import React from 'react';
import { HighlightLabel, PricingCardContainer } from './PricingCard.styles';
import Typography from 'src/app/atoms/Typography/Typography';
import { IPricingCard } from 'src/hooks/usePricingCards';
import PriceBlock from './PriceBlock';
import KeyFeatures from './KeyFeatures';
import useOnMobile from 'src/hooks/useOnMobile';

const PricingCard = ({ planTitle, supportingText, price, keyFeatures, bannerText }: IPricingCard): JSX.Element => {
  const isMobile = useOnMobile(640);

  const align = isMobile ? 'center' : 'left';
  const paddingTop = isMobile && !bannerText ? 'spacing-none' : 'spacing-6xl';

  return (
    <PricingCardContainer
      direction='column'
      borderRadius='radius-2xl'
      overflow='hidden'
      paddingTop={paddingTop}
      position='relative'
      border='1px solid var(--border-secondary-alt)'
      background='bg-secondary-alt'
    >
      {bannerText && (
        <HighlightLabel
          justify='center'
          align='center'
          background='bg-brand-solid'
        >
          <Typography
            type='paragraph'
            size='sm'
            fontWeight='font-weight-semibold'
            color='text-white'
          >
            {bannerText}
          </Typography>
        </HighlightLabel>
      )}
      <PriceBlock
        planTitle={planTitle}
        supportingText={supportingText}
        price={price}
        align={align}
      />
      <KeyFeatures keyFeatures={keyFeatures} />
    </PricingCardContainer>
  );
};

export default PricingCard;
